<div class="excel-button-container">
    <p-button label="Export Report" icon="pi pi-cloud-download" outlined (click)="onExportExcel()" />
</div>
